<template>
  <div class="photos">

    <v-card>
      <v-progress-linear v-bind:indeterminate="true" height="5" v-if="showLoading"></v-progress-linear>
      <v-alert error value="true" v-if="errorMessage">
        {{ errorMessage }}
      </v-alert>

      <div v-if="attemptedToLoadPhotos && !showLoading && !errorMessage && photos.length == 0">
        <h3 class="display-3">Ooops!</h3>
        <span class="subheading">You don't have any uploaded photos!</span>
        <v-divider class="my-3"></v-divider>
        <div class="title mb-3">Answer a question, upload a photo and it will be visible here.</div>
        <v-divider class="my-3"></v-divider>
      </div>

      <gallery :images="photos" :index="index" @close="index = null"></gallery>
      <div
        class="gallery_image"
        v-for="(photo, imageIndex) in photos"
        :key="imageIndex"
        @click="index = imageIndex"
        :style="{ backgroundImage: 'url(' + photo + ')', backgroundSize: '300px 300px', height: '200px', width: '200px', margin: '10px' }"
      ></div>
    </v-card>

  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import VueGallery from 'vue-gallery'

  const actions = mapActions([
    'getPhotos',
  ])

  export default {
    name: 'Photos',
    data() {
      return {
        photos: [],
        errorMessage: '',
        showLoading: false,
        index: null,
        attemptedToLoadPhotos: false,
      }
    },
    created() {
      this.loadPhotos()
    },
    methods: {
      ...actions,
      loadPhotos() {
        this.attemptedToLoadPhotos = true
        this.showLoading = true
        this.getPhotos().then((result) => {
          this.photos = result.data.map((url) => {
            return url
          })
          this.showLoading = false
        },
          (error) => {
            this.showLoading = false
            this.errorMessage = error.message
          })
      }
    },
    components: {
      'gallery': VueGallery
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .photos {
    background-color: #fafafa;
  }

  .gallery_image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }

  .photos_frame {
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Photos.vue